import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import Pagination from '../../model/pagination';
import {environment} from '../../environments/environment';
import QueryEncoder from '../queryEncoder';
import {catchError, switchMap} from 'rxjs/operators';
import CooperationEventModel from '../../model/cooperationEvent.model';
import CooperationTaskModel from '../../model/cooperationTask.model';
import GenericCrudService from "../genericCrud.service";

@Injectable()
export default class EventService extends GenericCrudService<CooperationEventModel> {
  public constructor(protected http: HttpClient) {
    super(http);
  }

  getApiName() {
    return 'events'
  }


  public done(event: CooperationEventModel): Observable<boolean> {
    return this.http.post(environment.apiUrl + '/events/' + event.id + '/done', {}).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }

  public undone(event: CooperationEventModel): Observable<boolean> {
    return this.http.post(environment.apiUrl + '/events/' + event.id + '/undone', {}).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }
}
